import { getAppFromUrl } from './PathUtil';

const setCookie = (name: string, value: string, expires?: string) => {
  const app = getAppFromUrl(window.location.toString());
  document.cookie = `${name}=${value}; expires=${expires}; domain=.${app}.ee; path=/;`;
};

const CookieApi = {
  getCookieValue(name: string) {
    const pair = document.cookie.match(new RegExp(`${name}=([^;]+)`));
    if (!!pair) {
      return pair[1];
    }
    return null;
  },

  updateCookie(cookieName: string, cookieContent: string) {
    const expirationDate = new Date();
    expirationDate.setFullYear(new Date().getFullYear() + 1);
    setCookie(cookieName, cookieContent, expirationDate.toUTCString());
  }
};

export default CookieApi;
